import { Box, Skeleton } from '@mui/material';

export const loadingSkeleton = (
  <Box px={2}>
    <Skeleton width="85%" />
  </Box>
);
